export * from './bericht-filter.component';
export * from './bericht-filter.component.module';